module.exports = __webpack_public_path__ + "img/med_jawa_logo.52f8124e.png";